module.exports = __webpack_public_path__ + "static/media/P.d8e6877b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/P.jpg
// module id = 84
// module chunks = 0